module.exports = __webpack_public_path__ + "static/img/main-date.01ce273.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-date.svg
// module id = m/gy
// module chunks = 1